function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#073C50",
  fillRule: "evenodd",
  d: "M37,42 L37,48 L11,48 L11,42 L37,42 Z M48,0 L48,38 L0,38 L0,0 L48,0 Z M43,5 L5,5 L5,33 L43,33 L43,5 Z M24.7990893,9.41088029 L28.6216215,10.5891197 L22.9112661,29.1150804 L19.0887339,27.936841 L24.7990893,9.41088029 Z M14.4319423,12.6085844 L17.3052419,15.3914156 L13.791,19.019 L17.297747,22.6008874 L14.4394372,25.3991126 L8.20848312,19.0343652 L14.4319423,12.6085844 Z M33.0742879,12.6085844 L39.3052419,18.9733319 L33.0817828,25.3991126 L30.2084831,22.6162815 L33.722725,18.9886971 L30.215978,15.4068097 L33.0742879,12.6085844 Z"
});

var SvgNetwork = function SvgNetwork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNetwork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Network.f3cc17cb.svg";
export { ForwardRef as ReactComponent };